const TYPES = {
    GET_PAYOUT_REPORT: 'GET_PAYOUT_REPORT',
    GET_PAYOUT_REPORT_COMPLETE: 'GET_PAYOUT_REPORT_COMPLETE',
    GET_PAYOUT_REPORT_FAILED: 'GET_PAYOUT_REPORT_FAILED',

    GET_PAYOUT_OPTIONS: 'GET_PAYOUT_OPTIONS',
    GET_PAYOUT_OPTIONS_COMPLETE: 'GET_PAYOUT_OPTIONS_COMPLETE',
    GET_PAYOUT_OPTIONS_FAILED: 'GET_PAYOUT_OPTIONS_FAILED',

    SET_PAYOUT_DATE: 'SET_PAYOUT_DATE'
};

export default {
    TYPES,

    getPayoutReport: payload => ({
        type: TYPES.GET_PAYOUT_REPORT,
        payload
    }),

    getPayoutReportSuccess: payload => ({
        type: TYPES.GET_PAYOUT_REPORT_COMPLETE,
        payload
    }),

    getPayoutReportFailed: payload => ({
        type: TYPES.GET_PAYOUT_REPORT_FAILED,
        payload
    }),

    getPayoutOptions: () => ({
        type: TYPES.GET_PAYOUT_OPTIONS
    }),

    getPayoutOptionsSuccess: payload => ({
        type: TYPES.GET_PAYOUT_OPTIONS_COMPLETE,
        payload
    }),

    getPayoutOptionsFailed: payload => ({
        type: TYPES.GET_PAYOUT_OPTIONS_FAILED,
        payload
    }),

    setPayoutDate: payload => ({
        type: TYPES.SET_PAYOUT_DATE,
        payload
    })
};
